import { PaginationArrowButton } from './pagination-arrow-button'
import { PaginationDivider } from './pagination-divider'
import { PaginationPageButton } from './pagination-page-button'
import * as styles from './pagination.styles'

type Props = {
  onPageChange: (page: number) => void
  pagesNeeded: number
  currentPage: number
}

export const PaginationNavigation = ({
  onPageChange,
  pagesNeeded,
  currentPage,
}: Props) => {
  const threshold = 2
  const displayFirstItem = currentPage > threshold
  const displayLastItem = currentPage < pagesNeeded - 1

  const previousPage = currentPage - 1
  const nextPage = currentPage + 1

  return (
    <div css={styles.items} data-testid="pagination-navigation">
      <PaginationArrowButton
        currentPage={currentPage}
        pagesNeeded={pagesNeeded}
        type="backward"
        onPageChange={onPageChange}
      />
      {/* always show first and last page */}
      {displayFirstItem && (
        <PaginationPageButton
          currentPage={currentPage}
          pageNumber={1}
          onPageChange={onPageChange}
        />
      )}

      <PaginationDivider page={currentPage} type="before" />

      {/* display `previous` page button if possible */}
      {previousPage > 0 && (
        <PaginationPageButton
          currentPage={currentPage}
          pageNumber={previousPage}
          onPageChange={onPageChange}
        />
      )}

      {/* `current` item is always displayed in center of list */}
      <PaginationPageButton
        currentPage={currentPage}
        pageNumber={currentPage}
        onPageChange={onPageChange}
      />

      {/* display `next` page button if possible */}
      {currentPage < pagesNeeded && (
        <PaginationPageButton
          currentPage={currentPage}
          pageNumber={nextPage}
          onPageChange={onPageChange}
        />
      )}

      <PaginationDivider
        page={currentPage}
        pagesTotal={pagesNeeded}
        type="after"
      />

      {/* always show first and last page */}
      {displayLastItem && (
        <PaginationPageButton
          currentPage={currentPage}
          pageNumber={pagesNeeded}
          onPageChange={onPageChange}
        />
      )}
      <PaginationArrowButton
        currentPage={currentPage}
        pagesNeeded={pagesNeeded}
        type="forward"
        onPageChange={onPageChange}
      />
    </div>
  )
}
